<script setup lang="ts">
  /**
   * SwitchLabel 组件
   * @description
   * 1. 包装 Switch 组件，提供 Label 和背景样式
   * 2. 解决 Switch.vue 代码冗余问题
   * 3. 完整支持禁用状态和不同尺寸
   */
  import { type SwitchRootEmits, type SwitchRootProps, useForwardPropsEmits } from 'reka-ui'
  import { type HTMLAttributes } from 'vue'
  import { reactiveOmit } from '@vueuse/core'
  import { cn } from '@rapoo/element/lib/utils'
  import { Switch, switchWrapperVariants, type SwitchVariants } from '.'

  const props = defineProps<
    SwitchRootProps & {
      class?: HTMLAttributes['class']
      size?: SwitchVariants['size']
      label: string // Label 必传，否则直接用 Switch 即可
    }
  >()

  const emits = defineEmits<SwitchRootEmits>()

  const delegatedProps = reactiveOmit(props, 'class', 'size', 'label')

  const forwarded = useForwardPropsEmits(delegatedProps, emits)

  /**
   * 切换开关状态
   * @description
   * 点击 label 时触发，如果未禁用，则反转当前状态
   */
  const toggle = () => {
    if (props.disabled) return
    const currentValue = (props as any).modelValue ?? (props as any).checked ?? false
    emits('update:modelValue', !currentValue)
  }
</script>

<template>
  <div
    :class="
      cn(
        switchWrapperVariants({ size }),
        props.disabled && 'cursor-not-allowed opacity-50',
        props.class,
      )
    "
  >
    <Switch v-bind="forwarded" :size="size" />
    <span :class="cn(props.disabled && 'cursor-not-allowed')" @click="toggle">
      {{ label }}
    </span>
  </div>
</template>
